export default "__VITE_ASSET__6ca4b4a6__"